export const modelExecutionRecordColumns = [
  {
    display_name: "",
    key: "select",
    headerStyles: {
        background: "#7593F2",
        color:"#ffffff",
        padding: "4px 8px",
        width: "50px"
      },
    cellStyles: {
        width: "50px"
      },
    _config: {
      type: "checkbox",
      displayInColumn: true,
      value: "id",
      isClickable: "true"
    }
  },
  {
    display_name: "#",
    headerStyles: {
      background: "#7593F2",
      color:"#ffffff",
      padding: "4px 8px",
      width: "8%"
    },
    key: "serial_number"
  },
  {
    display_name: "Name",
    key: "name"
  },
  {
    display_name: "Author",
    key: "author"
  },
  {
    display_name: "Publish Date",
    key: "publishDateTime"
  },
  {
    display_name: "Trained Date",
    key: "trainedDateTime"
  },
  {
    display_name: "Source File Size",
    key: "source"
  }
];
